module.exports = __webpack_public_path__ + "static/media/lesson.b2ef35f3.jpg";